export const config = {
  filesListPath: {
    listFiles: "liste-fichiers.json",
    data: "/themes/mieux-consommer/recherche-themopompes-efficaces/data",
    neep: "/themes/mieux-consommer/recherche-themopompes-efficaces/data/",
    es: "https://codaservicesprod-back.devtechnucom.com/energystar/depot-csv/"
  // es: "/data/_thermo/"
  },

  dateAffichageOH: new Date("2026-03-16"), //(2026, 2, 16) 16 mars 2026

  listName: "liste-fichiers.json",

  fromURLParam: false,

  DATE_NEEP_FINAL: new Date("2025-08-25"), //(2025, 7, 25) 25 août 2025
  DATE_ENERGY_STAR_SWITCH: new Date("2025-11-26") //(2025, 10, 26) 26 novembre 2025
};
